
import Breadcrumbs from "~/components/UI/Breadcrumbs";
import {
  email,
  required,
  minLength
} from "vuelidate/lib/validators";
import errorParseNetwork from "~/helpers/errorParseNetwork";
import {getAdditionalData, parseUtmLabels} from "~/helpers/formSend";
import {formaterOgTitle} from "~/helpers/formaterOgTitle";

export default {
  head: function () {
    if (this.isBlock) {
      return null
    }
    return this.headPage
  },

  fetch: async function () {
    if (this.isBlock) {
      return
    }
    await this.getCmsPageContent();
  },

  data: function () {
    return {
      filterData: [],

      headPage: {},
      form: {
        cityFrom: "",
        cityTo: "",
        cargoName: "",
        cargoType: {label: "Любой", slug: "Любой"},
        transportType: {label: "Любой", slug: "Любой"},
        cargoWeight: "",
        cargoLength: "",
        cargoWidth: "",
        cargoHeight: "",

        name: "",
        phone: "",
        email: "",
        note: ""
      },

      distance: "",

      isAccept: false,
      isFullForm: false,
    }
  },
  validations: function () {
    const form = {
      cityFrom: {
        required,
      },
      cityTo: {
        required
      },
      cargoName: {
        required
      },
      cargoType: {
        required
      },
      name: {
        required
      },
      phone: {
        required,
        minLength: minLength(18)
      },
      email: {
        email
      },
    };
    if (!this.isFullForm) {
      delete form.cityFrom;
      delete form.cityTo;
      delete form.cargoName;
      delete form.cargoType;
    }

    return {
      form,
    };
  },
  computed: {
    breadcrumbs: function () {
      return [
        {title: "Главная", path: "/"},
        {title: "Расчет стоимости перевозки", path: this.$route.path},
      ]
    },

    optionsTipGruza: function () {
      const options = this.filterData.find((t) => t.slug === 'tip-gruza')?.variants || [];

      return [
        {label: "Любой", slug: "Любой"},
        ...options
      ]
    },
    optionsNashTransport: function () {
      const options = this.filterData.find((t) => t.slug === 'transport')?.variants || [];

      return [
        {label: "Любой", slug: "Любой"},
        ...options
      ]
    },

    errorCityFrom: function () {
      const error = this.$v?.form?.cityFrom;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }

      return null
    },
    errorCityTo: function () {
      const error = this.$v?.form?.cityTo;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }

      return null
    },
    errorCargoName: function () {
      const error = this.$v?.form?.cargoName;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }

      return null
    },
    errorCargoType: function () {
      const error = this.$v?.form?.cargoType;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }

      return null
    },
    errorName: function () {
      const error = this.$v?.form?.name;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }

      return null
    },
    errorPhone: function () {
      const error = this.$v?.form?.phone;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }
      if (!error.minLength) {
        return "Неправильный формат ввода"
      }

      return null
    },
    errorEmail: function () {
      const error = this.$v?.form?.email;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }
      if (!error.email) {
        return "Неправильный формат ввода"
      }

      return null
    },
  },

  props: {
    isBlock: {
      type: Boolean,
      default: false
    },
    image: {}
  },

  components: {
    Breadcrumbs,

    Select: () => import("~/components/form/Select.vue"),
    FormSlider: () => import("~/components/form/FormSlider.vue"),
    DatePicker: () => import("~/components/form/DatePicker.vue"),
    YandexMap: () => import("~/components/cargo-rate-calculator/YandexMap.vue"),
    InputDropDown: () => import("~/cms/blocks/components/CalculatorBlock/InputDropDown.vue")
  },

  mounted: async function () {
    this.initStateFromSearch();
    await this.getFilterData();
  },

  watch: {
    isFullForm: function () {
      if (!!this.$refs.refMap) {
        this.$refs.refMap.setCitiesForMap()
      }
    }
  },

  methods: {
    getCmsPageContent: async function () {
      const path = this.$route.path;
      const response = await this.$api.agent.transport.get(`/cms/page-by-path?path=${path}`).then((res) => {
        return res.data
      }).catch(() => {
        return null
      })
      if (!response) {
        return
      }

      const title = response?.page?.title_tag || response?.page?.title;
      const description = response?.page?.description || "";

      this.headPage = {
        title: title,
        meta: [
          {name: 'og:title', hid: 'og:title', property: 'og:title', content: formaterOgTitle(title, this.$store.state.appState.config)},

          {hid: 'metadescription', name: 'description', content: description},
          {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
        ],
      }
    },

    // Логика с фильтром
    getFilterData: async function () {
      const response = await this.$api.agent.transport.get(`/categories/catalog/filter-data`).then((res) => {
        return res.data?.options || []
      }).catch(() => {
        return []
      });
      this.filterData = response;
    },

    // Логика с данными формами
    initStateFromSearch: function () {
      const query = this.$route?.query || {};

      let form = {...this.form}
      form.cityFrom = query?.from || "";
      form.cityTo = query?.to || "";

      this.form = form;
    },
    changeForm: function (value, name) {
      let form = {...this.form};
      form[name] = value;
      this.form = form;
    },
    changeDistance: function (distance) {
      this.distance = distance;
    },


    submitForm: async function () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }

      this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: true });

      let message = [
        `Перевозка из ${this.form.cityFrom} в ${this.form.cityTo}`,
        `Наименование груза: ${this.form.cargoName}`,
        `Тип груза: ${this.form.cargoType?.label}`,
      ];
      let dimensions = [];
      if (this.form.cargoWidth) {
        dimensions.push(`Ширина (м): ${this.form.cargoWidth}`);
      }
      if (this.form.cargoHeight) {
        dimensions.push(`Высота (м): ${this.form.cargoHeight}`);
      }
      if (this.form.cargoLength) {
        dimensions.push(`Длина (м): ${this.form.cargoLength}`);
      }
      if (this.form.cargoWeight) {
        dimensions.push(`Масса груза (т): ${this.form.cargoWeight}`);
      }
      if (dimensions.length) {
        message.push(`Параметры груза: ${dimensions.join("; ")}`)
      }
      if (this.form.note) {
        message.push(`Комментарий пользователя: ${this.form.note}`);
      }

      let userName = [this.form.name]

      const utmLabels = parseUtmLabels();
      const sbjsCurrent = this.$cookies.get('sbjs_current');
      const body = {
        type: "Расчет стоимости перевозки",
        name: userName.filter((t) => !!t).join(" "),
        email: this.form.email,
        phone: (this.form?.phone || "").replace(/[^\d]/g, ''),
        url: window.location.href,
        message: message.join("\n"),
        source: sbjsCurrent || '',
        additional_data: {}
      };
      if (!!utmLabels) {
        body.additional_data = {
          ...body.additional_data,
          ...utmLabels
        }
      }
      body.additional_data = await getAdditionalData({...body.additional_data}, {
        $yandexMetrika: this.$yandexMetrika
      });
      const response = await this.$api.agent.transport.post("/form/send", body).then((res) => {
        return res.data
      }).catch((err) => {
        return {
          error: errorParseNetwork(err.response)
        }
      });
      if (response.error) {
        this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: false });

        this.$toast.error(response.error);

        return
      }
      this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: false });
      this.$toast.success("Заявка успешно отправлена");
      this.resetForm();

      let reachGoal = "poluchut_racget_big_forma";
      if (!this.isFullForm) {
        reachGoal = "poluchut_racget_malenkaa_forma"
      }

      this.$yandexMetrika.reachGoal(reachGoal);
      this.$yaglaaction(reachGoal);
    },
    resetForm: function () {
      this.form = {
        cityFrom: "",
        cityTo: "",
        cargoName: "",
        cargoType: null,
        transportType: null,
        cargoWeight: "",
        cargoLength: "",
        cargoWidth: "",
        cargoHeight: "",

        name: "",
        phone: "",
        email: "",
        note: ""
      };
      this.distance = "";
      this.$v.$reset();
    },
  }
}
